export const ACTION = {
  OVERLAY: 'overlayView',
};

export const NAME = {
  PAGE_VIEW: 'pageView',
  API_CALL: 'apiCall',
  EXCEPTION: 'exception',
  LOG: 'log',
};

export const LOG_LEVEL = {
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
  DEBUG: 'debug',
  FATAL: 'fatal',
};

export const EVENT = {
  PAGE_VIEW: 'pageView',
  API_CALL: 'apiCall',
  EXCEPTION: 'exception',
  ANALYTICS: 'analytics',
  CLICK_STREAM: 'clickStream',
  LOG: 'log',
} as const;

export const ERROR_MESSAGES = {
  ENSURE_INITIALIZATION_DONE:
    'Please ensure initialization method is called before any of the logs method. ',
  ENABLE_DEBUG: 'You can also enable debug mode for further analysis. ',
  INITIALIZATION:
    'An error occurred during beacon initialization. This means you will not be able to send data to Pulse. Please check all arguments are provided correctly.',
  API_LOG: 'Could not send API logs to Pulse.',
  PAGEVIEW_LOG: 'Could not send Page View logs to Pulse.',
  EXCEPTION_LOG: 'Could not send Exception logs to Pulse.',
  INFO_LOG: 'Could not send Info logs to Pulse.',
  WARN_LOG: 'Could not send Warn logs to Pulse.',
  ERROR_LOG: 'Could not send Error logs to Pulse.',
};
